///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";

import messages from "../helpers/messages";

export const FileDropper = ({
  handleDrop,
  children,
  boxClassName,
  openFileDialogButtonId = "choose-file",
  multiple = true,
  disabled = false,
  acceptedFileTypes = null,
  show = true,
  ...rest
}) => {
  const [invalidFileMessage, toggleInvalidFileMessage] = useState(false);
  const { supportedFiles } = useSelector(state => state.app).supportedFiles;
  const acceptedFiles = supportedFiles
    .filter(({ fileType }) => {
      return (
        acceptedFileTypes === null ||
        acceptedFileTypes.some(ft => ft === fileType)
      );
    })
    .map(({ mimeType, fileExtension }) => mimeType + ", ." + fileExtension)
    .join(", ");
  const onDrop = useCallback(
    selectedFiles => {
      if (selectedFiles && selectedFiles.length) {
        handleDrop(selectedFiles);
        toggleInvalidFileMessage(false);
      }
    },
    [handleDrop]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptedFiles,
    maxSize: 500 * 1024 * 1024,
    multiple: multiple,
    disabled: disabled,
    onDropRejected: () => toggleInvalidFileMessage(true)
  });

  const handleClick = event => {
    if (!event || !event.target || event.target.id !== openFileDialogButtonId) {
      event && event.stopPropagation && event.stopPropagation();
    }
  };

  return (
    <>
      {show && (
        <div {...getRootProps()} className="no-focus" {...rest}>
          <input data-testid="files" {...getInputProps()} />
          <div
            onClick={handleClick}
            className={
              boxClassName +
              " file-drop-zone text-center py-20 box--border-all box--border-dashed border-color-gray box--rounded-all pos-relative " +
              (isDragActive ? "file-drop-progress" : "")
            }
          >
            {children}
          </div>
        </div>
      )}
      {invalidFileMessage && show && (
        <div
          data-testid="invalid-file-message"
          style={{ color: "#790000" }}
          className="pt-12"
        >
          {messages.fileTypeNotSupportedMessage.defaultMessage}
        </div>
      )}
    </>
  );
};

export default FileDropper;
